import { SearchFilter } from "../search";

export interface TypeDefinition {
    id: number;
    name: string;
    sort?: number;
}

export const typeDefinitionsAsSearchFilter = (defs: TypeDefinition[]) => {
    const filters: SearchFilter[] = [];
    for (const d of defs) {
        filters.push({
            checked: false,
            count: 0,
            id: d.id,
            name: d.name,
        });
    }
    return filters;
};



// WEBPACK FOOTER //
// ./src/models/generic/TypeDefinition.ts